import cn from 'classnames';
import { getTranslation } from '../../helpers';
import { h } from 'preact';
import { useCartContext } from '../context/CartContext';

import { useEffect, useState } from 'preact/hooks';

const QuantitySelector = ({ item, setError }) => {
  const { updateLineItem } = useCartContext();
  const [quantity, setQuantity] = useState(item.quantity);
  const [updatingQuantity, setUpdatingQuantity] = useState(null);

  useEffect(() => {
    if (item.quantity < updatingQuantity) {
      setError(item.quantity);
    }
    setQuantity(item.quantity);
    setUpdatingQuantity(null);
  }, [item]);

  const updateQuantity = value => {
    setUpdatingQuantity(value);
    updateLineItem(item.key, value);
  };

  const Button = ({ children, label, onClick, disabled, className }) => (
    <button
      class={cn('inline-block', className, {
        'cursor-default text-grey-3': disabled,
      })}
      type="button"
      aria-label={label}
      onClick={onClick}
      disabled={disabled || updatingQuantity !== null}
    >
      {children}
    </button>
  );

  return (
    <div class="type-body-base inline-flex items-stretch rounded-full border border-black">
      <Button
        className="pl-3 pr-1 text-right xs:pl-6 xs:pr-2"
        label={getTranslation('general.form.decrement')}
        onClick={() => updateQuantity(quantity - 1)}
        disabled={quantity === 1}
      >
        -
      </Button>

      <input
        class="hide-arrows inline-block h-10 w-10 border-0 px-0 text-center focus-within:ring-0 md:h-12"
        type="number"
        name="quantity"
        value={quantity}
        aria-label={getTranslation('general.form.quantity')}
        min="1"
        onInput={e => updateQuantity(e.target.value)}
      />

      <Button
        className="pl-1 pr-3 text-left xs:pl-2 xs:pr-6"
        label={getTranslation('general.form.increment')}
        onClick={() => updateQuantity(quantity + 1)}
      >
        +
      </Button>
    </div>
  );
};

export default QuantitySelector;
